Ext.ns('mx.data');

mx.data.Country = mx.data.Record.create(
    [{name: 'id', type: 'string'}, {name: 'name', type: 'string'}, {name: 'code', type: 'string'}],
    MXAT.API('countries/')
);
